import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './cycleCountList.html'

/**
 * CycleCount.
 *
 * @namespace routes.OperationCycleCountList
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.cycleCount.list',
  label: 'OPERATIONS.CYCLECOUNT.TITLE',
  url: '/cycleCount',
  params: {
    closed: {
      value: 'false',
      squash: true,
    },
  },
  resourceType: 'CycleCount',
  resourceList: {
    searchParameters: ['closed.to', 'closed.from', 'closed'],
  },
  component: 'tmrOperationCycleCount',
  accessControl: ['Operation.perform', 'Operation.CycleCount.perform'],
  mainMenu: false,
}

/**
 * CycleCount component.
 *
 * @type {ngComponent}
 */
export const tmrOperationCycleCount = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
  controller: 'tmrOperationCycleCountController',
}

/**
 * Controller of component {@link tmrOperationCycleCountController}.
 *
 * @type {ngController}
 */
export class tmrOperationCycleCountController {
  static ngType = 'controller'

  constructor($state, $mdDialog, TmrPromptModal, TmrToast, CycleCount) {
    'ngInject'
    Object.assign(this, {
      $state,
      $mdDialog,
      TmrPromptModal,
      TmrToast,
      CycleCount,
    })
  }

  createNewCycleCount(event) {
    this.$mdDialog.show(this.$mdDialog.tmrNewCycleCount(event))
  }
}
